document.addEventListener('DOMContentLoaded', function(){
    fetchShippingBarData()
});

// Options for the observer (which mutations to observe)
const config = { attributes: true, childList: true, subtree: true };
// Callback function to execute when mutations are observed
const callback = (mutationList, observer) => {
  for (const mutation of mutationList) {
    if (mutation.type === 'childList') {
      fetchShippingBarData()
    }   
  }
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);
observer.observe(document.querySelector('#subtotal_observer'), config);

function fetchShippingBarData(){ 
  fetch('/cart.js')
    .then((resp) => resp.json())
    .then((data) => {
      computeShippingNeeded(data)
    });
}

function getPercentageChange (target, completed) {
  return (completed / target * 100);
}

function computeShippingNeeded(data){
  let formatter = new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD',});
  let shippingThreshold = parseInt("8000");

  let totalPrice = data.total_price;
  let isSubOnly = true;

  data.items.forEach(function(item) {
    if (!item.requires_shipping) {
      totalPrice -= item.final_price;
    }
    else {
      isSubOnly = false;
    }
  });

  if (!isSubOnly) {
    totalPrice = data.total_price;
  }

  let remainingAmount = shippingThreshold - totalPrice;

  if (remainingAmount > 0){
    document.getElementById('shipping-bar-cart-page').style.display = 'block';
    document.getElementById('shipping-message-cart-page').innerHTML = "You're " + formatter.format((remainingAmount)/100) + " away from free shipping!";
    document.getElementById('threshold-unlocked').style.display = 'none';

    if (!isSubOnly) {
      document.getElementById('shipping-bar-cart-page').style.display = 'block';
    }
    else {
      document.getElementById('shipping-bar-cart-page').style.display = 'none';
    }
  } else {
    document.getElementById('shipping-bar-cart-page').style.display = 'none';
    document.getElementById('threshold-unlocked').style.display = 'flex';
  } 
}
